import events from "../events/EventsObservable";
import SystemConfig, {CONFIG_PARAMS} from "../system/SystemConfig";
import {getDeviceStr, mobileAndTabletCheck} from "../device/device";

export const AUTOSTARTS = [0, 10, 50, 100, 1000];
export const MAX_AUTOSTART = 999;

export const AUTOSTART_EVENTS = {
    "AUTOSTART_ON_SET_COUNT": "AUTOSTART_ON_SET_COUNT"
};

interface IAutoStartSettings {
    values: Array<any>;
}

export default class GameAutostart {

    private _config: SystemConfig;
    private _autostart: number;
    private _last_autostart: number;

    private _settings: IAutoStartSettings;
    private _values: Array<number>;

    constructor(config) {
        this._config = config;
        this._autostart = this._last_autostart = 0;
        this._settings = this._config.get(CONFIG_PARAMS.AUTOSTART);
        this.setValues();
    }

    setSettings(settings: any) {
        this._settings = settings;
        this.setValues();
    }

    /**
     * Set this._values, allow only numeric values or Infinity
     * @param values
     */
    setValues(values: Array<any> = this._settings.values) {
        if (values.length) {
            this._values = [];
            for (let i = 0; i < values.length; i++) {
                if (Number.isInteger(values[i])) {
                    this._values[i] = values[i];
                } else if (typeof(values[i]) === "string") {
                    if (values[i] === "Infinity") {
                        this._values[i] = Infinity;
                    }
                }
            }
        } else {
            this._values = AUTOSTARTS;
        }
    }

    isAutostart(): boolean {
        return this._autostart > 0 && !this._config.get(CONFIG_PARAMS.DISABLE_AUTOSTART);
    }

    isInfinity(): boolean {
        return this._autostart === Infinity;
    }

    setAutostart(num) {
        this._autostart = num;

        events.dispatch(AUTOSTART_EVENTS.AUTOSTART_ON_SET_COUNT, { count: this._autostart });
    }

    stopAutostart() {
        this._last_autostart = this._autostart;
        this.setAutostart(0);
    }

    decAutostart() {
        if(this._autostart > 0) {
            this._last_autostart = --this._autostart;
        }

        events.dispatch(AUTOSTART_EVENTS.AUTOSTART_ON_SET_COUNT, { count: this._autostart });
    }

    getAutostart(): number {
        return this._autostart;
    }

    getValues(): Array<number> {
        return this._values;
    }

    getMinAutostart(): number {
        return this._values[0];
    }

    continue() {
        this._autostart = this._last_autostart;
    }

    isPaused() {
        return !this.isAutostart() && this._last_autostart > 0;
    }

    getLastAutostart() {
        return this._last_autostart;
    }

    resetLastAutostart() {
        this._last_autostart = 0;
    }
}

export function getNearestAutostart(num: number, range: Array<number>): number {

    if(num === Infinity) {
        return range[range.length - 1];
    }

    for (let i = 0; i < range.length - 2; i++) {
        let aMin = range[i];
        let aMax = range[i + 1];


        if (aMax < num) {
            continue;
        }

        if (num - aMin < aMax - num) {
            return aMin
        } else {
            return aMax;
        }
    }

    return range[0];
}